import * as React from "react"

function SvgChevronDown(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 10"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.042}
        d="M.564.861l7.222 8.164a.325.325 0 00.459.027l.028-.027L15.496.86"
      />
    </svg>
  )
}

export default SvgChevronDown
